<h1>Panel użytkownika</h1>
<p-tabs [value]="activeTab()" class="customTab" lazy>
  <p-tablist>
    <p-tab value="0">Moje dane</p-tab>
    <p-tab value="1">Członkowie rodziny</p-tab>
    <p-tab value="2">Ustawienia konta</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      <app-beneficiary-settings-beneficiary-data
        [beneficiary]="beneficiary()"
      ></app-beneficiary-settings-beneficiary-data>
    </p-tabpanel>
    <p-tabpanel value="1">
      <ng-template #content>
        <app-family-members-table></app-family-members-table>
      </ng-template>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-form-beneficiary-settings-beneficiary-preferences
        [beneficiaryPreferences]="beneficiary().notyfikacjeBeneficjenta!"
      ></app-form-beneficiary-settings-beneficiary-preferences>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
